// src/App.js
import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import AppRouter from './routes/AppRouter';
import Layout from './components/Layout';
import { ThemeProvider } from "./context/ThemeContext"
import RouteSEO from './components/RouteSEO';
import AnalyticsTracker from './components/AnalyticsTracker';
import { Toaster } from 'react-hot-toast';
// import EmailTour from './components/EmailTour';

// Public Google OAuth Client ID (safe in client code); override via env if rotated.
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '380203042913-lnlih9ukufstt1gdb9klo59dhqkdfdr5.apps.googleusercontent.com';

// Global Avani AI widget — mounted here (not in MainLayout) so it appears on
// EVERY page, including public SEO landing pages, and nudges logged-out
// visitors to the get-access form.
const AiChatWidget = lazy(() => import('./components/AiChatWidget'));

function App() {
  // Scrolling the wheel over a focused number input makes the browser step the
  // value up or down — the same silent edit the spinner arrows caused, and
  // easier to trigger by accident on a long form. Blur instead: the page
  // scrolls normally and the amount stays exactly as typed.
  useEffect(() => {
    const onWheel = (e) => {
      const el = document.activeElement;
      if (el && el.type === 'number' && el === e.target) el.blur();
    };
    document.addEventListener('wheel', onWheel, { passive: true });
    return () => document.removeEventListener('wheel', onWheel);
  }, []);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Router>
      <AuthProvider>
        <ThemeProvider attribute="class">
          <RouteSEO />
          <AnalyticsTracker />
          <Toaster position="top-right" toastOptions={{ duration: 4000, style: { borderRadius: '12px', fontSize: '14px' } }} />
          <Layout>
            <AppRouter />
          </Layout>
          <Suspense fallback={null}>
            <AiChatWidget />
          </Suspense>
          {/* Email CRM tour — commented out after initial rollout */}
          {/* <EmailTour /> */}
        </ThemeProvider>
      </AuthProvider>
    </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
